module.exports = __webpack_public_path__ + "static/media/PieChart2.9607a586.png";